import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'i18n/utils'
import { CardSection } from 'shared/components/CardSection'
import { LocationCard } from 'shared/components/LocationCard'
import { getScanTicketPendingSelector, scanticketTicketSelector } from 'scanticket/selectors'
import Button from 'shared/components/Button'
import Input from 'shared/components/Textfield'
import ErrorMessage from 'shared/components/ErrorMessage'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'
import { ANALYTICS_FLOW_TYPE_SCAN_TICKET } from 'analytics/constants'
import { MemoizedTicketScanner } from './TicketScanner'

import { scanTicket } from '../actions'

import styles from './styles.module.scss'

const ScanQr = ({ locationName }) => {
    const [ticketNumber, setTicketNumber] = React.useState()
    const dispatch = useDispatch()
    const t = useTranslation()
    const pending = useSelector(getScanTicketPendingSelector)
    const ticket = useSelector(scanticketTicketSelector)
    const sendGTAGEvent = useSendGTAGEvent()

    const submitTicketNumber = () => {
        sendAmplitudeEvent('User entered QR code', {
            'Location Name': locationName,
            'Flow Type': ANALYTICS_FLOW_TYPE_SCAN_TICKET,
        })
        sendGTAGEvent('enter_qr_code', {
            flow_type: ANALYTICS_FLOW_TYPE_SCAN_TICKET,
            location_name: locationName,
        })
        dispatch(scanTicket(ticketNumber))
    }

    const handleScanResult = result => {
        sendAmplitudeEvent('User scans QR code', {
            'Location Name': locationName,
            'Flow Type': ANALYTICS_FLOW_TYPE_SCAN_TICKET,
        })
        sendGTAGEvent('scan_qr_code', { flow_type: ANALYTICS_FLOW_TYPE_SCAN_TICKET, location_name: locationName })
        dispatch(scanTicket(result[0].rawValue))
    }

    return (
        <>
            <CardSection>
                <LocationCard locationName={locationName} />
            </CardSection>
            <CardSection className={styles.scanQrContainer}>
                <div
                    className="d-flex flex-column
             justify-content-center align-items-sm-center">
                    <h1>
                        <T>scanticket.title</T>
                    </h1>
                    <p className="mt-6 align-self-start">
                        <T>scanticket.scanner.label</T>
                    </p>
                    <div className={styles.scannerContainer}>
                        <MemoizedTicketScanner paused={pending === true || Boolean(ticket)} onScan={handleScanResult} />
                    </div>
                    <div className="w-100 d-flex justify-content-between mt-6">
                        <Input
                            onChange={e => setTicketNumber(e.target.value)}
                            placeholder={t('scanticket.input.placeholder')}
                        />
                        <Button
                            className="ml-2"
                            btnStyle="outline"
                            isLoading={pending === true}
                            disabled={pending === true || !ticketNumber}
                            onClick={submitTicketNumber}>
                            <T>scanticket.input.submit</T>
                        </Button>
                    </div>
                </div>
                {pending instanceof Error && <ErrorMessage className="mt-4" messages={[pending.message]} />}
            </CardSection>
        </>
    )
}

export default ScanQr
